import { createReducer, Action, on } from '@ngrx/store';

import { TenantUserActions } from './tenant-user.actions';
import { TenantUserState } from './tenant-user.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: TenantUserState = {
  users: [],
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      TenantUserActions.LoadTenantUsersSuccess,
      (state, action): TenantUserState => ({ ...state, users: action.users })
    )
  )
);

export function reducer(state: TenantUserState | undefined, action: Action) {
  return featureReducer(state, action);
}
